__turbopack_context__.v({
  "geoLocationButton": "FixedHeader-module-scss-module__ZWfF3W__geoLocationButton",
  "productImage": "FixedHeader-module-scss-module__ZWfF3W__productImage",
  "selectedProduct": "FixedHeader-module-scss-module__ZWfF3W__selectedProduct",
  "variantInfo": "FixedHeader-module-scss-module__ZWfF3W__variantInfo",
});
